import { axios } from "../../helpers/axios";
import { ASSIGN_PROCESS_URL, GET_SIDEBAR_MENU_LIST_URL } from "./assignprocessConstants";

export const api_get_assign_process_list_url = async (page, limit, qn, qs) => {
    return axios.get(ASSIGN_PROCESS_URL, { params: { page, limit, qn, qs } });
};

export const api_get_sidebar_menu_list_url = async () => {
    return axios.get(GET_SIDEBAR_MENU_LIST_URL);
};

export const api_create_assign_process_url = async (data) => {
    return axios.post(ASSIGN_PROCESS_URL, data);
};

export const api_update_assign_process_url = async (assign_process_id, updated_data) => {
    return axios.put(ASSIGN_PROCESS_URL + "/" + assign_process_id, updated_data);
};

export const api_activate_deactivate_assign_process_url = async (assign_process_id, updated_data) => {
    return axios.patch(ASSIGN_PROCESS_URL + "/" + assign_process_id + "/" + updated_data);
};

export const api_get_assign_process_details_url = async (assign_process_id) => {
    return axios.get(ASSIGN_PROCESS_URL + "/" + assign_process_id);
};